import type { IncidentFieldRule } from './types';

export const itSystemsNetworkFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of IT or network security incident is this?',
        description: 'Select the type of IT or network incident.',
        order: 90,
    },
    {
        key: 'impactedServices',
        label: 'Which services were affected?',
        description: 'List the services or systems impacted, e.g. DNS, email, VPN.',
        order: 100,
    },
    {
        key: 'observedBehavior',
        label: 'What unusual behaviour was observed?',
        description: 'Describe the unusual activity, e.g. slow performance, outage, errors.',
        order: 110,
    },
    {
        key: 'durationMinutes',
        label: 'How long did the incident last (in minutes)?',
        description: 'Enter total duration of incident. Leave blank if ongoing.',
        kind: 'number',
        order: 120,
        parse: (value: unknown) => {
            if (typeof value === 'number' && Number.isFinite(value)) {
                return String(value);
            }
            return undefined;
        },
    },
    {
        key: 'additionalDetails',
        label: 'Please provide additional details',
        description: 'Add any relevant technical details or context about the incident.',
        kind: 'textarea',
        order: 130,
    },
    {
        key: 'observationsOtherInfo',
        label: 'Any other relevant information?',
        description: 'Include any additional information that may help the investigation.',
        kind: 'textarea',
        order: 140,
    },
];
